module.exports = __webpack_public_path__ + "img/logo1mix-1.daa3d341.webp";